// GET RESIDENT DOCUMENTS
export const GET_RESIDENT_DOCUMENTS =
  "app/RESIDENT_DOCUMENTS/GET_RESIDENT_DOCUMENTS";
export const GET_RESIDENT_DOCUMENTS_SUCCESS =
  "app/RESIDENT_DOCUMENTS/GET_RESIDENT_DOCUMENTS_SUCCESS";
export const GET_RESIDENT_DOCUMENTS_FAILURE =
  "app/RESIDENT_DOCUMENTS/GET_RESIDENT_DOCUMENTS_FAILURE";

// SAVE RESIDENT DOCUMENT
export const SAVE_RESIDENT_DOCUMENT =
  "app/RESIDENT_DOCUMENTS/SAVE_RESIDENT_DOCUMENT";
export const SAVE_RESIDENT_DOCUMENT_SUCCESS =
  "app/RESIDENT_DOCUMENTS/SAVE_RESIDENT_DOCUMENT_SUCCESS";
export const SAVE_RESIDENT_DOCUMENT_FAILURE =
  "app/RESIDENT_DOCUMENTS/SAVE_RESIDENT_DOCUMENT_FAILURE";

// DELETE RESIDENT DOCUMENT
export const DELETE_RESIDENT_DOCUMENT =
  "app/RESIDENT_DOCUMENTS/DELETE_RESIDENT_DOCUMENT";
export const DELETE_RESIDENT_DOCUMENT_SUCCESS =
  "app/RESIDENT_DOCUMENTS/DELETE_RESIDENT_DOCUMENT_SUCCESS";
export const DELETE_RESIDENT_DOCUMENT_FAILURE =
  "app/RESIDENT_DOCUMENTS/DELETE_RESIDENT_DOCUMENT_FAILURE";
